const Builder = require('./BuilderBase');

module.exports = class RangeDateTime extends Builder {
    constructor(title, properties) {
        super('rangeType_DateTime', title, properties);
    }
};
